import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import TransportationChoiceModal from "../components/Modal/TransportationChoiceModal";
import Navbar from "../components/Navbar";
import TourManagementSidebar from "../components/tour/TourManagementSidebar";
import CustomRadio from "../components/common/CustomRadio";
import { useDispatch, useSelector } from "react-redux";
import { setTransportationChoiceModal } from "../reducer/modalReducer";
import { RootState } from "../app/store";
import {
  setEditedVehicle,
  setPackageData,
  setVehicles,
} from "../reducer/tourReducer";
import { Paths } from "../router/Paths";
import useOnLoadPage from "../hooks/useOnLoadPage";
import { usePackage } from "../hooks/usePackage";
import { addActiveTab } from "../reducer/sideBarSlice";

function TourManagementPackageTransportationPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({
    transportation: "",
    vehicles: "",
  });
  const { vehicles, packageData } = useSelector((state: RootState) => {
    const { modeOfTransport } = state.tour.packageData || {};
    return {
      vehicles: modeOfTransport || [], // Extract vehicles from modeOfTransport
      packageData: state.tour.packageData,
    };
  });

  const { PrepackageDataId } = useSelector((state: RootState) => state.tour);

  const { createPrePackage } = usePackage();
  const progressref = useRef(8);

  useOnLoadPage({ tabActive: "create" });

  console.log("vehicle", vehicles);

  const handleRemoveVehicle = (index: number) => {
    const updatedVehicles = vehicles.filter((_, idx) => idx !== index);
    dispatch(setVehicles(updatedVehicles));

    // Clear vehicles error if there's at least one vehicle
    if (updatedVehicles.length > 0 && errors.vehicles) {
      setErrors({ ...errors, vehicles: "" });
    }
  };

  const handleEditVehicle = (index: number) => {
    dispatch(setEditedVehicle(index + 1));
    dispatch(setTransportationChoiceModal(true));

    if (errors.vehicles) {
      setErrors({ ...errors, vehicles: "" });
    }
  };

  const validate = () => {
    let valid = true;
    let newErrors = { transportation: "", vehicles: "" };

    // Validate if user selected Yes/No
    if (packageData.transportation === undefined) {
      newErrors.transportation = "Please select if transportation is used.";
      valid = false;
    }

    // Validate if transportation is yes, there must be at least one vehicle
    if (packageData.transportation && vehicles.length === 0) {
      newErrors.vehicles = "Please add at least one vehicle.";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const onContinue = () => {
    if (!validate()) return;
    dispatch(addActiveTab(Paths.tourManagementPackageExtraInfo));
    navigate(Paths.tourManagementPackageExtraInfo);
  };

  const onSave = async () => {
    if (!validate()) return;

    const updatedPackageData = {
      ...packageData,
      _id: PrepackageDataId,
      progress: Number(progressref.current),
    };

    dispatch(setPackageData(updatedPackageData));
    setLoading(true);

    try {
      await createPrePackage(updatedPackageData);
      localStorage.setItem("packageData", JSON.stringify(updatedPackageData));
      navigate(Paths.welcome);
    } catch (error) {
      console.error("Error saving package:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleEntry = () => {
    dispatch(setTransportationChoiceModal(true));
    if (errors.vehicles) {
      setErrors({ ...errors, vehicles: "" });
    }
  };

  console.log("packagedata", packageData);

  const handleBack = () => {
    navigate(Paths.tourManagementPackageFood);
  };

  return (
    <div className={Classname.container}>
      <TransportationChoiceModal />
      <Navbar />
      <div className={Classname.content}>
        <TourManagementSidebar selected={9} />

        <div className={Classname.detail}>
          <div className={Classname.title}>
            Is transportation used during this activity?
          </div>
          <p className={Classname.description}>
            Provide the main transportation type(s) that customers use during
            the experience, like a Segway or bike. Transportation used for
            pickup and drop-off will be added later.
          </p>

          <CustomRadio
            label="No"
            value={false}
            selected={packageData.transportation}
            onSelect={() => {
              dispatch(
                setPackageData({
                  transportation: false,
                })
              );
              setErrors({ ...errors, transportation: "" });
            }}
          />
          <CustomRadio
            label="Yes"
            value={true}
            selected={packageData.transportation}
            onSelect={() => {
              dispatch(
                setPackageData({
                  transportation: true,
                })
              );

              setErrors({ ...errors, transportation: "" });
            }}
          />

          {errors.transportation && (
            <p className="text-red-500 text-sm mt-1">{errors.transportation}</p>
          )}

          {packageData.transportation && (
            <>
              <div className={Classname.vehiclesContainer}>
                {vehicles.map((vehicle, index) => (
                  <div className={Classname.vehicle} key={index}>
                    <span className={Classname.vehicleName}>{vehicle}</span>
                    <span
                      className={Classname.vehicleEdit}
                      onClick={() => handleEditVehicle(index)}
                    >
                      Edit
                    </span>
                    <span
                      className={Classname.vehicleRemove}
                      onClick={() => handleRemoveVehicle(index)}
                    >
                      Remove
                    </span>
                  </div>
                ))}

                <div
                  className={Classname.highlightButton}
                  onClick={handleEntry}
                >
                  Add entry
                </div>

                {errors.vehicles && (
                  <p className="text-red-500 text-sm mt-1">{errors.vehicles}</p>
                )}
              </div>

              <div className={Classname.title}>
                Do customers travel to a different city/town during the
                activity?
              </div>
              <CustomRadio
                label="Yes"
                value={true}
                description="Example: going from Lagos to Abuja"
                selected={packageData.customerCityTravel}
                onSelect={() => {
                  dispatch(
                    setPackageData({
                      customerCityTravel: true,
                    })
                  );
                }}
              />
              <CustomRadio
                label="No"
                value={false}
                description="Example: going from one part of Lagos to another part of Lagos"
                selected={packageData.customerCityTravel}
                onSelect={() => {
                  dispatch(
                    setPackageData({
                      customerCityTravel: false,
                    })
                  );
                }}
              />
            </>
          )}

          <div className="flex justify-between items-centers mt-10">
            <button className={Classname.saveButton2} onClick={handleBack}>
              Back
            </button>
            <div className={Classname.buttonsContainer}>
              <button
                className={Classname.saveButton}
                onClick={onSave}
                disabled={loading}
              >
                {loading ? "Please Wait..." : "Save and exit"}
              </button>
              <button className={Classname.continueButton} onClick={onContinue}>
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TourManagementPackageTransportationPage;

const Classname = {
  container:
    "flex w-full min-h-screen relative bg-white flex-col items-center font-main",
  content:
    "flex flex-col lg:flex-row w-full max-w-7xl flex-1 pt-10 lg:pt-0 max-lg:px-4",
  detail: "flex flex-col py-10 lg:px-6 w-full",
  title: "font-bold text-lg mt-6 mb-2",
  input: "flex w-full h-14 border border-gray-400 rounded-md px-4 mt-2",
  textarea:
    "flex w-full h-44 py-4 border border-gray-400 rounded-md px-4 mt-2 mb-6",
  description: "flex text-base mb-4",
  buttonsContainer: "flex max-lg:justify-between gap-3 max-lg:w-full",
  vehiclesContainer:
    "flex flex-1 flex-col py-4 gap-3 font-bold ml-8 border-l-4 border-gray-200 flex-wrap",
  vehicle:
    "w-full max-w-64 lg:max-w-md flex items-center px-2 h-14 rounded-md border border-gray-400 gap-3 ml-5 flex-wrap",
  vehicleName: "flex flex-1",
  vehicleEdit: "text-primary1 cursor-pointer",
  vehicleRemove: "text-red-600 cursor-pointer",
  highlightButton:
    "font-bold flex items-center  justify-center gap-2 cursor-pointer text-primary1  border-2 border-blue-500 p-3 rounded-3xl w-36  ml-5",
  saveButton:
    "h-12 px-6 flex items-center lg:justify-center font-bold text-gray-700 border border-gray-500 rounded-md",
  saveButton2:
    "h-12 px-6 flex items-center lg:justify-center font-bold text-gray-700 border border-gray-500 rounded-md max-lg:hidden",
  continueButton:
    "h-12 px-6 flex items-center justify-center text-white font-bold bg-primary1 rounded-md",
};
